export const variables = {
    bodySite: document.querySelector('body'),
    header: document.querySelector('.header'),
    headerWrapper: document.querySelector('.header__wrapper'),
}